import(/* webpackMode: "eager" */ "/srv/panel/app/loading.tsx");
